import { Policy } from 'models/policies';
import { AppState } from 'reducers';

export const getPolicyDetail = (
  state: AppState,
  policyId: string
): Policy | undefined => state.policies.items?.[policyId];
